const server = "https://sharearxus.onrender.com/"

export default server 
